import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { tableHeaderCustomer } from '../helper';
import {
    getCustomerDetails,
    handleLoader
}
    from '../../../../redux/actions/WholesaleCustomerAction';
import CustomerTable from './customerTable'

const Customer = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const { customerData, salesChannelFilterData, isLoading } = useSelector(
        ({ wholesaleCustomerReducer, marketPlaceReducer }) =>
        ({
            customerData: wholesaleCustomerReducer.customerData,
            isLoading: wholesaleCustomerReducer.isLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );    

    const [customerDataToShow, setDataToShow] = useState([])
    const [filterData, setFilterData] = useState({});    

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');    
    dvTb.style.display = "none";  
  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Wholesale customer Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }


    const countryCodeOptions = [];
    const callApi = () => {
        dispatch(handleLoader(true));
        dispatch(getCustomerDetails());
    }

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(customerData?.modal?.data || []);
    }, [customerData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])


    const dataToShowForDatesSelected = customerDataToShow?.filter(item => filterBasedOnFilter(item))

    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                        <Row>
                        <Col sm="7">
                            <div className="card__title mb-2 ">
                                <h5 className="bold-text text-right">Wholesale customer</h5>
                                
                            </div> 
                            </Col>
                <Col sm="5" className='text-right'>
                <button className="btn btn-sm btn-primary
                                             apply-date-button" type="button" style={{marginTop:0}}
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button></Col>
                            </Row>                                                    
                        </CardBody>
                    </Card>
                </Col>              
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <CustomerTable
                                    data={dataToShowForDatesSelected}
                                    tableHeaderData={tableHeaderCustomer}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>
        </Container>
    );
};

Customer.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
}

export default connect(state => ({
    rtl: state.rtl,
}))(Customer);